// client/src/components/agendamentos/ColunaProfissional.js
import React from 'react';
import CardEvento from './CardEvento';

const ColunaProfissional = ({ eventos = [], onEventClick, bodyStyle, pixelsPorMinuto, horaInicio, horaFim, clientes, recursos }) => {
    const alturaTotal = (horaFim - horaInicio) * 60 * pixelsPorMinuto;
    const estiloDoCorpoComAltura = { ...bodyStyle, height: `${alturaTotal}px`, position: 'relative' };

    return (
        <div className="coluna-profissional">
            <div className="coluna-body" style={estiloDoCorpoComAltura}>
                {eventos.map(evento => (
                    <CardEvento 
                        key={`${evento.type}-${evento._id}`} 
                        evento={evento} 
                        onEventClick={onEventClick}
                        coluna={evento.coluna}
                        totalColunas={evento.totalColunas}
                        pixelsPorMinuto={pixelsPorMinuto}
                        horaInicio={horaInicio}
                        clientes={clientes}
                        recursos={recursos}
                    />
                ))}
            </div>
        </div>
    );
};

export default ColunaProfissional;